import React, { useCallback } from 'react';

// DEPENDENCIES
import { useDispatch } from 'react-redux';
import { useFormikContext } from 'formik';

// GLOBAL VARIABLES
import { INVENTORY_FILE_TYPE_IDS } from 'globals.js';

// GLOBAL FUNCTIONS
import { lookupActions } from 'actions.js';

// LOCAL TOOLS
import VinNumber from 'routers/interface/tools/VinNumber';
import StockNumber from 'routers/interface/tools/StockNumber';
import Attachment from 'routers/interface/tools/attachment/Attachment';

// MAIN COMPONENT
const VINStock = ({
  index,
  isNew,
  required,
  ...props
}) => {

  // REDUX
  const dispatch = useDispatch();

  // CONTEXT
  const { values, setFieldValue } = useFormikContext() || {};

  // CALLBACKS
  const handleVINSuccess = useCallback(
    ({
      vehicle_year,
      make_id,
      make_name,
      model,
      model_code,
      vehicle_trim,
      body_style,
      engine,
      engine_type,
      drivetrain,
      transmission_name,
      ext_color,
      int_color
    }) => {
      setFieldValue(`aryTrade[${index}].inventory.vehicle_year`, vehicle_year);
      setFieldValue(`aryTrade[${index}].inventory.make_id`, make_id);
      setFieldValue(`aryTrade[${index}].inventory.make`, make_name);
      setFieldValue(`aryTrade[${index}].inventory.model`, model);
      setFieldValue(`aryTrade[${index}].inventory.vehicle_trim`, vehicle_trim);
      setFieldValue(`aryTrade[${index}].inventory.body_style`, body_style);
      setFieldValue(`aryTrade[${index}].inventory.engine`, engine);
      setFieldValue(`aryTrade[${index}].inventory.engine_type`, engine_type);
      setFieldValue(`aryTrade[${index}].inventory.model_code`, model_code);
      setFieldValue(`aryTrade[${index}].inventory.drivetrain_name`, drivetrain);
      setFieldValue(`aryTrade[${index}].inventory.transmission_name`, transmission_name);
      dispatch(lookupActions.load('exteriorColors', ext_color));
      dispatch(lookupActions.load('interiorColors', int_color));
    },
    [setFieldValue, dispatch, index]
  );
  const handleSearch = useCallback(
    (name, label, val) => values.aryTrade.filter((_value, i) => i !== index).find(({ inventory: { [name]: num }}) => num === val) && `A trade with the same ${label} has already been added to this deal, the same ${label} cannot be used more than once.`,
    [values, index]
  );
  const handleVINSearch = useCallback(
    vin_num => handleSearch('vin_num', 'VIN', vin_num),
    [handleSearch]
  )
  const handleStockNoSearch = useCallback(
    stock_num => handleSearch('stock_num', 'stock#', stock_num),
    [handleSearch]
  )

  const vehicle = values.aryTrade?.[index]?.inventory;
  const stockNum = vehicle?.stock_num;
  const vinNum = vehicle?.vin_num;
  const dailySalesInventoryId = vehicle?.daily_sales_inventory_id;
  const uploadParams = { stockNum, vinNum, dailySalesInventoryId };
  const noVinStock = !stockNum || !vinNum;

  // RENDER
  return (<>
      <VinNumber
        name={`aryTrade[${index}].inventory.vin_num`}
        onSearch={handleVINSearch}
        onSuccess={handleVINSuccess}
        useAddon
        required={required}
        {...props}
      />
      <Attachment.Upload
        label="Photo Proof of VIN"
        name={`aryTrade[${index}].inventory.documentAttachment.vin_photo`}
        uploadType="inventory"
        documentType={isNew ? INVENTORY_FILE_TYPE_IDS.VIN_PHOTO_NEW : INVENTORY_FILE_TYPE_IDS.VIN_PHOTO_USED}
        docrName={`aryTrade[${index}].inventory.docrAttachmentRequest`}
        requestedFor="Inventory"
        uploadParams={uploadParams}
        noVinStock={noVinStock}
        vehicle={vehicle}
        {...props}
      />
      <StockNumber
        name={`aryTrade[${index}].inventory.stock_num`}
        label="Stock"
        onSearch={handleStockNoSearch}
        required={required}
        {...props}
      />
    </>);
};

export default VINStock;
